export default "__VITE_ASSET__DHTiZwHA__"